<template>
    <div class="goalPlanning">
        <div class="content">
            <div class="flexBox">
                <p class="title">院校属地 | </p>
                <div>
                    <span v-for="(item,index) in provinceList" :key="index"
                          @click="onChangeProvance(item.provinceID)"
                          :class="province.includes(item.provinceID)?'active':((province.length == 0 && index == 0)?'active':'')"
                    >
                    {{item.provinceName}}
                    </span>
                </div>
            </div>
            <div class="flexBox">
                <p class="title">院校类型 | </p>
                <div>
                    <span v-for="(item,index) in typeList" :key="index"
                          @click="onChangeType(item.collegeFieldID)"
                          :class="type.includes(item.collegeFieldID)?'active':((type.length==0&&index==0)?'active':'')"
                    >
                        {{item.collegeFieldName}}
                    </span>
                </div>
            </div>
            <div class="flexBox">
                <p class="title">特色标签 | </p>
                <div>
                    <span v-for="(item,index) in tagList" :key="index"
                          @click="onChangeTag(item.id)"
                          :class="tagData.includes(item.id)?'active':((tagData.length==0&&index==0)?'active':'')"
                    >
                        {{item.name}}
                    </span>
                </div>
            </div>
            <div class="tableBox">
                <p class="num">{{'共检索到['+pageData.total+ ']所院校'}}</p>
                <table class="gradeTable">
                    <thead>
                    <tr>
                        <th >院校名称</th>
                        <th width='180'>所在地</th>
                        <th width='140'>类型</th>
                        <th width='140'>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in schoolList" :key="index" >
                        <td class="titleBox">
                            <div class="logo">
                                <img :src="item.collegeImage" alt="">
                            </div>
                            <div class="schoolName">
                                <p class="school">{{item.collegeName}}</p>
                                <p>
                                    <span v-show="item.strengtheningPlan==1">强基计划</span>
                                    <span v-show="item.is211==1">211</span>
                                    <span v-show="item.is985==1">985</span>
                                    <span v-show="item.isDoubleLevel==1">双一流</span>
                                    <span v-show="item.hasGraduateCollege==1">研究生学院</span>
                                    <span v-show="item.isIndependent==1">独立学院</span>
                                    <span v-show="item.isPrivate==1">民办学院</span>
                                </p>
                            </div>

                        </td>
                        <td>
                            {{item.provinceName}}
                        </td>
                        <td>
                            {{item.collegeFieldName}}
                        </td>
                        <td class="btnTd">
                            <span class='checked btn' @click="addMessage('已设置为目标院校，请勿重复设置')" v-if="getHadChecked(item)">设为目标院校</span>
                            <span class='unCheck btn' @click="onChangethreee(item.collegeID,item.collegeName)" v-else>设为目标院校</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <Pagination :pageData="pageData" @changePage="changeCurrent"></Pagination>
            </div>

            <p class="tuijianTitle">目标大学</p>
            <div class="threeScoreBox">
                <div class="scoreBox"  v-for="(value,index) in goalPlanObj.universityScore" :key="index">
                    <div class="schoolName">
                        <p class='name'>
                            <span class='circle'></span>
                            {{value.universityName+'——院校录取数据（'+myStudentProvince+'）：'}}
                        </p>
                        <div class="btn" @click="detailThreee(index)">
                            ×
                        </div>
                    </div>
                    <table class="threeTable" v-if="value.universityScore.length">
                        <thead>
                        <tr>
                            <th width='100'>录取年份</th>
                            <th width='130'>考生类别</th>
                            <th width='100'>录取批次</th>
                            <th width='120'>最低分</th>
                            <th width='120'>省控线</th>
                            <th width='120'>线差</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(val,index) in value.universityScore" :key="index">
                            <td>{{val.year}}</td>
                            <td>{{val.artsAndScience}}</td>
                            <td>{{val.batch}}</td>
                            <td>{{val.averageScore}}</td>
                            <td>{{val.provinceScore}}</td>
                            <td>{{val.differenceScore}}</td>
                        </tr>
                        </tbody>
                    </table>
                    <p v-else>
                        暂无此院校数据~~
                    </p>
                </div>
            </div>
            <div class="score">
                <p class='name'>
                    <span class='circle'></span>
                    目标分数及位次：
                </p>
                <div class="inputBox">
                    <el-input placeholder="分数" type='number'  v-model="goalPlanObj.score" ></el-input>
                    <span>/</span>
                    <el-input placeholder="位次" type='number'  v-model="goalPlanObj.rank" ></el-input>
                </div>
            </div>
            <div class="summary">
                <SummaryTitle title='咨询记录'/>
                <el-input class="area"   type="textarea" v-model="goalPlanObj.remarkLog"  rows="5" maxLength='500'></el-input>
            </div>
        </div>

    </div>
</template>
<script>
import SummaryTitle from './SummaryTitle.vue';
import Pagination from '../Pagination.vue';
export default {
    name: "goalPlanning",
    props: ['goalPlanObj'],
    components: {
        SummaryTitle,
        Pagination
    },
    data() {
        return {
            schoolList: [], //院校列表
            studentId: sessionStorage.getItem('myStudentStudentId'),//学生id
            myStudentProvince: sessionStorage.getItem('myStudentProvince'),//学生省份
            name: '',//大学名称
            schoolLevel: '',//办学层次
            province: [],//院校属地
            schoolNature: [],//办学性质
            type: [],//大学类别
            // 双一流 与 特色标签
            tagShuangyiliu: [],
            tag211: 0,
            tag985: 0,
            tagZhongdianxueke: 0,
            tagTesezhuanye: 0,
            tagBushenghejian: 0,
            tagBaoyanzige: 0,

            pageData: {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数
                total:100//总条数
            },
            provinceList: [],// 大学类别
            typeList: [], //院校类型
            tagList: [], //特色标签
            tagData:[],
        }
    },

    computed:{
    },
    watch: {

    },
    methods:{
        changeCurrent(value) {
            this.pageData.current = value;
            this.getUniversityList();
        },
        onChangeProvance(value) {
            let province = this.province;
            if(value == '不限') {
                this.province=[];
            }else {
                let index = province.indexOf(value);
                if(index >= 0) {
                    province.splice(index,1);
                }else {
                    province.push(value);
                }
                this.province = province;
                this.pageData = {
                    current:1,//当前页
                    pageSize:10,//每页多少条
                    totalPage:1,//总页数数
                    total:1//总条数
                }
            }
            this.getUniversityList();
        },
        onChangeType(value){
            let type = this.type;
            if(value == '不限') {
                this.type = [];
            }else {
                let index = type.indexOf(value);
                if(index >= 0) {
                    type.splice(index,1);
                }else {
                    type.push(value);
                }
                this.type = type;
                this.pageData = {
                    current:1,//当前页
                    pageSize:10,//每页多少条
                    totalPage:1,//总页数数
                    total:1//总条数
                };
                this.getUniversityList();
            }
        },
        onChangeTag(value) {
            let tag = this.tagData;
            if(value == '不限') {
                this.tagData = [];
            }else {
                let index = tag.indexOf(value);
                if(index >= 0) {
                    tag.splice(index,1);
                }else {
                    tag.push(value);
                }
                this.tagData = tag;
                this.pageData = {
                    current:1,//当前页
                    pageSize:10,//每页多少条
                    totalPage:1,//总页数数
                    total:1//总条数
                };
                this.getUniversityList();
            }
        },
        onChangeTagShuangyiliu(value) {
            let tagShuangyiliu = this.tagShuangyiliu;
            if(tagShuangyiliu.includes(value)) {
                tagShuangyiliu = tagShuangyiliu.filter((data)=>{
                    return data != value;
                })
            }else {
                tagShuangyiliu.push(value)
            }
            this.tagShuangyiliu = tagShuangyiliu;
            this.pageData = {
                current:1,//当前页
                pageSize:10,//每页多少条
                totalPage:1,//总页数数
                total:1//总条数
            };
            this.getUniversityList();
        },
        addMessage(value) {
            this.$message({
                message: value,
                type: 'warning'
            });
        },
        getHadChecked(value) {
            return this.goalPlanObj.universityScore.some((item)=>{return item.universityId == value.collegeID});
        },
        onChangethreee(id,name) {
            let universityId = id;
            let universityScore = this.goalPlanObj.universityScore;
            let schoolName = name;
            if(universityScore.length === 3) {
                this.addMessage('最多设置3所目标院校')
                return;
            }
            this.getUniversityScoreLineByUniversityIdAndProvince(universityId,schoolName);
        },
        detailThreee(index) {
            let universityScore = this.goalPlanObj.universityScore;
            let universityIdName = this.goalPlanObj.universityIdName;

            universityScore.splice(index,1);
            universityIdName.splice(index,1);
            this.goalPlanObj.universityScore = universityScore;
            this.goalPlanObj.universityIdName = universityIdName;

        },
        getUniversityScoreLineByUniversityIdAndProvince(id,name){
            let universityScore =  this.goalPlanObj.universityScore;
            let universityIdName =  this.goalPlanObj.universityIdName;
            let prams = {
                province: this.myStudentProvince,
                universityId:id,
                universityScore: this.goalPlanObj.universityScore,
                universityIdName: this.goalPlanObj.universityIdName
            }
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getUniversityScoreLineByUniversityIdAndProvince,prams, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                let data=res.data;
                if (data.code == 2000) {
                    let list = data.data;
                    let obj = {};
                    let objName = {};
                    obj.universityId = id;
                    obj.universityScore = list;
                    obj.universityName = name;
                    objName.id = id;
                    objName.name= name;
                    universityScore.push(obj);
                    universityIdName.push(objName);
                    this.goalPlanObj.universityScore = universityScore;
                    this.goalPlanObj.universityIdName = universityIdName;
                }else{

                }
            })
        },
        // 获取院校列表
        getUniversityList(){
            let pageData = this.pageData;
            let typeIs985 = 0;
            let typeIs211 = 0;
            let typeIsDoubleLevel = 0;
            let typeStrengtheningPlan = 0;
            let typeHasGraduateCollege = 0;
            let typeIsIndependent = 0;
            let typeIsPrivate = 0;

            this.tagData.forEach(item => {
                if(item == 'is985'){
                    typeIs985 = 1;
                }
                if(item == 'is211'){
                    typeIs211 = 1;
                }
                if(item == 'isDoubleLevel'){
                    typeIsDoubleLevel = 1;
                }
                if(item == 'strengtheningPlan'){
                    typeStrengtheningPlan = 1;
                }
                if(item == 'hasGraduateCollege'){
                    typeHasGraduateCollege = 1;
                }         
                if(item == 'isIndependent'){
                    typeIsIndependent = 1;
                }
                if(item == 'isPrivate'){
                    typeIsPrivate = 1;
                }              
            });

            let prams = {
                studentId: this.studentId,//学生id
                collegeName:'',
                arrangement:'', //层次
                provinceID: this.province,//院校属地
                collegeFieldID:this.type,//大学类别
                // 特色标签
                hasGraduateCollege:typeHasGraduateCollege,
                is211:typeIs211,
                is985:typeIs985,
                isDoubleLevel:typeIsDoubleLevel,
                isIndependent:typeIsIndependent,
                isPrivate:typeIsPrivate,
                strengtheningPlan:typeStrengtheningPlan,
                pageSize: pageData.pageSize,
                pageNumber: pageData.current
            }
            this.$ajax.post(this.G_acapi + this.ports.consultant.student.mine.planningContent.getUniversityList,prams, {
                headers: {
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res) => {
                if (res.data.code == 2000) {
                    this.schoolList = res.data.data.list;
                    let page = res.data.data.page;
                    this.pageData={
                        current:page.pageNumber,//当前页
                        pageSize:page.pageSize,//每页多少条
                        totalPage:page.count,//总页数数
                        total:page.count//总条数
                    };
                }else{

                }
            })
        },
        // 获取标签
        getLabel(){
            var _this = this;
            var token = window.sessionStorage.getItem('ymtxToken');
            this.$ajax
                .post(this.G_uri + '/college/dict', {
                },{
                    headers:{
                        token: token
                    }
                })
                // 监听数据返回
                .then(function(res) {
                let data = res.data.data;
                    let obj1 = {
                        provinceID:'不限',
                        provinceName:'不限'
                    }  ;
                    let obj2 = {
                        collegeFieldID:'不限',
                        collegeFieldName:'不限'
                    };       
                    let obj3 = {
                        id:'不限',
                        name:'不限'
                    };  

                    data.provinces.unshift(obj1);
                    data.collegeFields.unshift(obj2);
                    data.collegeProperties.unshift(obj3);
                    _this.provinceList = data.provinces;
                    _this.typeList = data.collegeFields;
                    _this.tagList = data.collegeProperties;
                })
                .catch(function(error) {
                    console.log(error)
                })
        }

    },
    created() {   
        this.getLabel();
        this.getUniversityList();
    },
    mounted(){
    }
}
</script>
<style scoped lang="less">
.goalPlanning {
    padding: 26px 0;
    font-size: 16px;
    .btn {
        cursor: pointer;
    }
    input {
        border: 1px solid #EAEAEA;
        background-color: #FDFDFD;
    }
    .name {
        font-size: 16px;
        display: flex;
        align-items: center;
        line-height: 24px;
        .circle {
            width: 12px;
            height: 12px;
            background: #00A2FF;
            border: 2px solid #D4F0FF;
            border-radius: 50%;
            margin-right: 5px;
        }
    }
    .content {
        background-color: #fff;
        .tuijianTitle {
            font-size: 20px;
            font-weight: bold;
            margin-bottom: 30px;
        }
        .tuijian {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 4px;
            padding: 20px 40px;
            margin-bottom: 40px;
            p {
                line-height: 30px;
            }
        }
        .flexBox {
            display: flex;
            margin-bottom: 10px;
            font-size: 16px;
            line-height: 30px;
            .title {
                line-height: 30px;
                font-weight: bold;
            }
            div {
                padding-left: 20px;
                display: flex;
                flex-wrap: wrap;
                flex: 1;
            }
            span {
                cursor: pointer;
                margin-right: 10px;
            }
            .active {
                color: #0095EB;
            }
        }
        .tableBox {
            padding-top: 20px;
            .num {
                font-size: 14px;
                line-height: 20px;
                color: #5C5C5C;
            }
        }
        .gradeTable {
            width: 100%;
            text-align: center;
            margin-bottom: 20px;
            .titleBox {
                display: flex;
                padding: 20px;
                .logo {
                    display: flex;
                    align-items: center;
                    margin-right: 20px;
                    img {
                        display: block;
                        width: 50px;
                        height: 50px;
                    }
                }
                .schoolName {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    .school {
                        width: 100%;
                    }
                    p {
                        text-align: left;
                    }
                }
            }

            thead {
                background: rgba(61, 144, 246, 0.2);
                color: #333;
                font-weight: bold;
                border-radius: 5px;
                tr {
                    line-height: 40px;
                    border-bottom: 1px solid #ECECEC;
                }
                th {
                    text-align: center;
                }
            }
            tbody {
                font-size: 14px;
                tr {
                    height: 80px;
                    border-bottom: 1px solid #ECECEC;
                }
            }
            td {
                line-height: 30px;
                p {
                    span {
                        border-radius: 3px;
                        background-color: #0095EB;
                        color: #fff;
                        margin-right: 3px;
                        padding: 0 3px;
                        font-size: 12px;
                    }
                }
            }
            .btnTd {
                span {
                    cursor: pointer;
                    color: #0095EB;
                    display: inline-block;
                    &:hover {
                        border-bottom: 1px solid #0095EB;
                    }
                }
                .checked {
                    border-bottom: 1px solid #0095EB;
                }

            }
        }
        .threeScoreBox {
            .scoreBox {
                margin-bottom: 40px;
                .schoolName {
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 15px;
                    .btn {
                        width: 18px;
                        height: 18px;
                        border: 1px solid #ABABAB;
                        color: #ABABAB;
                        line-height: 16px;
                        text-align: center;
                        font-size: 18px;
                        &:hover {
                            color: #0095EB;
                            border: 1px solid #0095EB;
                        }
                    }
                }
                .threeTable {
                    width: 100%;
                    font-size: 16px;
                    text-align: center;
                    thead {
                        background: rgba(61, 144, 246, 0.19);
                        color: #333;
                        font-weight: bold;
                        border-radius: 5px;
                    }
                    th {
                        text-align: center;
                        border: 1px solid rgba(61, 144, 246, 0.39);
                    }
                    td {
                        border: 1px solid rgba(61, 144, 246, 0.39);
                    }
                    tr {
                        line-height: 40px;
                        border-bottom: 1px solid #ECECEC;
                    }

                }
            }
        }
    }
    .score {
        display: flex;
        align-items: center;
        input {
            width: 100px;
        }
        div {
            padding-left: 10px;
            span {
                padding: 0 10px;
            }
        }

    }
    .ftBtnBox {
        padding: 45px 0;
        display: flex;
        justify-content: center;
    }
    .inputBox {
        display: flex;
        align-items: center;
    }
    .summary {
        padding: 20px 0px;
        .summaryTitle {
            margin-bottom: 20px;
        }
        .area {
            font-size: 16px;
            line-height: 26px;
            min-height: 128px;
            border-radius: 4px;
        }
    }
}
</style>
<style lang="less">
.goalPlanning {
    .inputBox {
        .el-input {
            padding-left: 0;
        }
        input {
            width: 100px;
            display: inline-block;
        }
    }
}
</style>

